export const setOdsToSelect = (value) =>
  sessionStorage.setItem("ods", JSON.stringify(value));
export const getOdsToSelect = () => JSON.parse(sessionStorage.getItem("ods"));
